import { render, staticRenderFns } from "./LklWithdral.vue?vue&type=template&id=dd5a21f8&scoped=true&"
import script from "./LklWithdral.vue?vue&type=script&lang=js&"
export * from "./LklWithdral.vue?vue&type=script&lang=js&"
import style0 from "./LklWithdral.vue?vue&type=style&index=0&id=dd5a21f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5a21f8",
  null
  
)

export default component.exports